import { Http } from "@/http";
import configLocation from "@/config";
const isProd = "cbo-merchant-web";

// 分页查询人员列表
/**
 * @param size
 * @param current
 * @param name
 * @param mobile
 * @param email
 * @param merchantId
 * @returns
 */
export const getListPage = (payload) => {
  return Http.post({
    url: `/${isProd}/user/list/page`,
    data: { ...payload },
  });
};
/**
 * 新增人员
 * @param name
 * @param roleId
 * @param email
 * @param mobile
 * @param password
 * @returns
 */
export const userAdd = (payload) => {
  return Http.post({
    url: `/${isProd}/user/add`,
    data: { ...payload },
  });
};
/**
 * 修改人员
 * @param name
 * @param roleId
 * @param email
 * @param mobile
 * @param password
 * @returns
 */
export const userUpdate = (payload) => {
  return Http.post({
    url: `/${isProd}/user/update`,
    data: { ...payload },
  });
};
/**
 * 删除人员
 * @param userId
 * @returns
 */
export const deleteUser = (payload) => {
  return Http.post({
    url: `/${isProd}/user/delete`,
    headers: {
      "Content-Type": `multipart/form-data`,
    },
    data: { ...payload },
  });
};
/**
 * 角色列表查询
 * @param current
 * @param size
 * @param name
 * @param merchantId
 * @returns
 */
export const roleListPage = (payload) => {
  return Http.post({
    url: `/${isProd}/role/list/page`,
    data: { ...payload },
  });
};
/**
 * 新建角色
 * @param name
 * @param dataPermissionsType
 * @param functionCodes
 * @returns
 */
export const roleAdd = (payload) => {
  return Http.post({
    url: `/${isProd}/role/add`,
    data: { ...payload },
  });
};
/**
 * 编辑角色
 * @param name
 * @param description
 * @param functionPermissions
 * @param dataPermissions
 * @returns
 */
export const updateRole = (payload) => {
  return Http.post({
    url: `/${isProd}/role/update?roleId=${payload.roleId}`,
    data: { ...payload },
  });
};
/**
 * 删除人员
 * @param userId
 * @returns
 */
export const deleteRole = (payload) => {
  return Http.post({
    url: `/${isProd}/role/delete`,
    headers: {
      "Content-Type": `multipart/form-data`,
    },
    data: { ...payload },
  });
};
export const userListPage = (payload) => {
  return Http.post({
    url: `/${isProd}/user/list/page`,
    data: { ...payload },
  });
};
/**
 * 删除人员
 * @param userId
 * @returns
 */
export const getMenuList = (payload) => {
  return Http.get({
    url: `/${isProd}/menu/tree/list`,
    params: { ...payload },
  });
};

/**
 * 根据客户主体ID查询广告账户信息
 * @param customerInfoId
 * @returns
 */
export const queryAdAccounts = (payload) => {
  return Http.get({
    url: `/${isProd}/customer/queryAdAccounts`,
    params: { ...payload },
  });
};
/**
 * 添加客户广告账户关联记录
 * @param customerInfoId
 * @returns
 */
export const addAdAccount = (payload) => {
  return Http.post({
    url: `/${isProd}/customer/addAdAccount`,
    data: { ...payload },
  });
};
/**
 * 删除客户广告账户关联记录
 * @param customerAdAccountId
 * @returns
 */
export const deleteCustomerAdAccount = (payload) => {
  return Http.post({
    url: `/${isProd}/customer/deleteCustomerAdAccount`,
    data: { ...payload },
    // headers: {
    //   "Content-Type": `multipart/form-data`,
    // },
  });
};
/**获取开户申请列表
 * @param customerInfoId
 */
export const queryOpenList = (payload) => {
  return Http.get({
    url: `${configLocation.apiCboAds}/cbo-merchant-ads/customer/queryOpenList`,
    params: { ...payload },
  });
};
